import React from 'react';
import { Link } from 'react-router-dom';
import { varToulonKeywords } from '../topKeywords';

export const VarToulon: React.FC = () => {
  return (
    <div className="bg-slate-50">
      <section className="border-b border-slate-200 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 lg:py-14">
          <p className="text-xs font-semibold uppercase tracking-wide text-primary mb-2">
            Var (83) · Toulon et littoral
          </p>
          <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-3">
            Nettoyage maison insalubre Var Toulon et nettoyage extrême 83
          </h1>
          <p className="text-sm text-slate-600 mb-4 max-w-3xl">
            Remise en état de <strong>maisons et appartements insalubres</strong> dans le Var :
            Toulon, La Seyne-sur-Mer, Hyères, Fréjus, Draguignan… Débarras, désinfection,
            nettoyage extrême et accompagnement des familles et professionnels.
          </p>
          <div className="flex flex-wrap items-center gap-3">
            <Link
              to="/devis"
              className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-800 transition-colors"
            >
              Devis nettoyage maison insalubre Var
            </Link>
            <p className="text-xs text-slate-500">
              Nous intervenons souvent pour :{' '}
              <em>{varToulonKeywords.slice(0, 3).join(', ')}</em>
            </p>
          </div>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 py-10 lg:py-14 grid gap-8 lg:grid-cols-[1.7fr,1.3fr]">
        <div>
          <h2 className="text-lg sm:text-xl font-semibold text-slate-900 mb-3">
            Intervention après Diogène, insalubrité ou accumulation extrême dans le Var
          </h2>
          <p className="text-sm text-slate-600 mb-3">
            Dans le Var, les situations de logements très dégradés nécessitent une intervention
            organisée : contact avec le propriétaire ou le syndic, estimation des volumes à
            évacuer, choix des protections et des produits adaptés.
          </p>
          <p className="text-sm text-slate-600 mb-3">
            Nos équipes se déplacent sur tout le département pour le{' '}
            <strong>nettoyage de maisons insalubres</strong>, pavillons, fermes, maisons de village
            ou appartements fortement encombrés.
          </p>
          <ul className="list-disc list-inside text-sm text-slate-600 mb-3">
            <li>Nettoyage maison insalubre Var après départ de locataire</li>
            <li>Nettoyage extrême après syndrome de Diogène</li>
            <li>Remise en état avant vente ou relocation</li>
            <li>Intervention possible en coordination avec notaires et agences</li>
          </ul>
          <p className="text-sm text-slate-600">
            Cette page répond notamment aux recherches comme{' '}
            <strong>nettoyage maison insalubre Var</strong> ou{' '}
            <strong>nettoyage logement insalubre Toulon</strong>, avec un contenu localisé sur le
            département 83.
          </p>
        </div>

        <aside className="rounded-2xl border border-slate-200 bg-white p-5 text-xs text-slate-600">
          <h3 className="text-sm font-semibold text-slate-900 mb-2">
            Villes couvertes dans le Var (83)
          </h3>
          <p className="mb-2">
            Toulon, La Seyne-sur-Mer, Hyères, La Garde, La Valette-du-Var, Fréjus, Saint-Raphaël,
            Draguignan, Brignoles et alentours.
          </p>
          <p className="mb-2">
            Interventions dédiées au{' '}
            <em>
              nettoyage maison insalubre Var, nettoyage logement insalubre Toulon, nettoyage extrême
              83
            </em>
            , avec prise en charge globale du débarras à la désinfection.
          </p>
          <Link
            to="/devis"
            className="inline-flex items-center justify-center rounded-md bg-mint px-3 py-1.5 text-[11px] font-semibold text-slate-950 hover:bg-emerald-400 transition-colors"
          >
            Expliquer ma situation dans le Var
          </Link>
        </aside>
      </section>
    </div>
  );
};
